import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { PublicSalon, SalonStatus } from '@concretecode/shared';

type SalonStoreState = {
  id: string | null;
  name: string | null;
  lang: string | null;
  timezone: string | null;
  editableHoursBefore: number;
  bookableInAdvanceMonths: number;
  status: SalonStatus | undefined;
  isLoading: boolean;
};

const initialState: SalonStoreState = {
  id: null,
  name: null,
  lang: null,
  timezone: null,
  editableHoursBefore: 0,
  bookableInAdvanceMonths: 0,
  status: undefined,
  isLoading: false,
};

export const SalonStore = signalStore(
  { providedIn: 'root' },
  withDevtools('salon-store'),
  withState(initialState),
  withMethods((store) => ({
    setSalon(salonId: string, publicSalon: PublicSalon): void {
      patchState(store, {
        id: salonId,
        name: publicSalon.name,
        lang: publicSalon.lang,
        timezone: publicSalon.timezone,
        editableHoursBefore: publicSalon.editableHoursBefore,
        bookableInAdvanceMonths: publicSalon.bookableInAdvanceMonths,
        status: publicSalon.status,
      });
    },
    setLoading(isLoading: boolean): void {
      patchState(store, { isLoading });
    },
    reset(): void {
      patchState(store, () => ({ ...initialState }));
    },
  })),
);
